export const STATUSES = {
  CREATED: "CR",
  CONFIRMED: "CONF",
  DELETED: "DEL",
  EXPIRED: "SCAD",
  USED: "UTIL",
};
